import { useSelector } from 'react-redux';

/**
 * The active business UUID for the Inventory Management section. This is the
 * same identifier the inventory backend scopes by (`businessUuid`), read from
 * the partner portal's current business.
 */
export const useBusinessUuid = () =>
  useSelector((state) => state.business?.currentBusiness?.uuid);

export default useBusinessUuid;
